import { render, staticRenderFns } from "./yhxy.vue?vue&type=template&id=48423e70&scoped=true"
import script from "./yhxy.vue?vue&type=script&lang=js"
export * from "./yhxy.vue?vue&type=script&lang=js"
import style0 from "./yhxy.vue?vue&type=style&index=0&id=48423e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48423e70",
  null
  
)

export default component.exports